import React, { useState, useEffect, Fragment } from 'react';
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import AttendanceFilter from './Chunks/AttendanceFilter';
import TablePanel from '../../../../components/ControlledTable/RerenderTable/TablePanel';
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';
import { format } from 'date-fns';

const Attendance = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [attendanceData, setAttendanceData] = useState([]);
    const [selectedData, setSelectedData] = useState({});
    const [fromDate, setFromDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [toDate, setToDate] = useState(new Date());
    const [isLoginMenu, setIsLoginMenu] = useState(false);
    const [isReload, setIsReload] = useState(false);

    const getData = async () => {
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C104CommonAcademicsAttendanceStudentsLogView?fromDate=${format(fromDate, "dd-MM-yyyy")}&toDate=${format(toDate, "dd-MM-yyyy")}`;
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("lmsToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        setAttendanceData(json.DATA || []);
                    } else {
                        alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
                    }
                    console.log(json);
                },
                error => {
                    if (error.status === 401) {
                        setIsLoginMenu(true);
                        setIsReload(true);
                    } else {
                        alert('Failed to fetch, Please try again later.');
                        console.log(error);
                    }
                });
        setIsLoading(false);
    };

    const onClearFilters = () => {
        setFromDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
        setToDate(new Date());
    };

    const onHandleChange = e => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handleDateChange = (date, name) => {
        if (name === 'fromDate') {
            setFromDate(date);
        } else if (name === 'toDate') {
            setToDate(date);
        }
    };

    useEffect(() => {
        getData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        { name: "Section", dataIndex: "sectionLabel", sortIndex: "sectionLabel", sortable: true, customStyleHeader: { width: '12%' } },
        { name: "Section Type", dataIndex: "sectionTypeLabel", sortIndex: "sectionTypeLabel", sortable: true, customStyleHeader: { width: '17%' } },
        { name: "Course Id", dataIndex: "courseId", sortable: false, customStyleHeader: { width: '10%' } },
        { name: "Course Label", dataIndex: "courseLabel", sortable: false, customStyleHeader: { width: '17%' } },
        { name: "Class Schedule", dataIndex: "startTimestamp", sortIndex: "startTimestampSimple", sortable: true, customStyleHeader: { width: '15%' } },
        { name: "Joined On", dataIndex: "joinedOn", sortable: false, customStyleHeader: { width: '15%' } },
        {
            name: "Late Minutes", renderer: rowData => {
                return (
                    <Fragment>
                        {rowData.lateMinutes > 0 ? rowData.lateMinutes : ""}
                    </Fragment>
                );
            }, sortIndex: "lateMinutes", sortable: true, customStyleHeader: { width: '13%' }
        },
        { name: "Teacher Name", dataIndex: "teacherName", sortIndex: "teacherName", sortable: true, customStyleHeader: { width: '17%' } },
        {
            name: "Status", renderer: rowData => {
                return (
                    <Fragment>
                        <span style={{
                            fontWeight: 600,
                            color: `${rowData.isPresent === 0 ? '#d26161' : 'rgb(28 126 96)'}`
                        }}> {rowData.isPresent === 0 ? 'Absent' : 'Present'} </span>

                    </Fragment>
                )
            }, sortIndex: "isPresent", sortable: true, customStyleHeader: { width: '15%' }
        },
    ];

    return (
        <Fragment>
            <LoginMenu reload={isReload} open={isLoginMenu} handleClose={() => setIsLoginMenu(false)} />
            <div style={{
                padding: 20
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 8
                }}>
                    <IconButton
                        onClick={() => navigate('/dashboard')}
                        style={{ marginRight: 10, color: "#1d5f98" }}
                        size="large"
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography style={{ color: '#1d5f98', fontWeight: 600, textTransform: 'capitalize', flex: 1 }} variant="h5">
                        Student Attendance Report
                    </Typography>
                </div>
                <Divider style={{
                    backgroundColor: 'rgb(58, 127, 187)',
                    opacity: '0.3',
                }} />
                <AttendanceFilter isLoading={isLoading} handleDateChange={handleDateChange} onClearFilters={onClearFilters} values={{ fromDate, toDate }} getDataByStatus={() => getData()} onHandleChange={e => onHandleChange(e)} />
                <div style={{
                    marginTop: 15,
                    marginBottom: 15,
                    color: '#174A84',
                    font: 'Bold 16px Lato',
                    letterSpacing: '1.8px'
                }}>
                </div>
                <TablePanel isShowIndexColumn data={attendanceData} isLoading={isLoading} sortingEnabled columns={columns} />

            </div>
        </Fragment>
    );
};
export default Attendance;